(function() {
  var loaded = false;

  function loadWhatsAppScript() {
    if (loaded) return;
    loaded = true;

    var s = document.createElement('script');
    s.src = window.__WC_WHATSAPP_SCRIPT_URL__;
    s.defer = true;
    document.body.appendChild(s);
  }

  window.addEventListener('scroll', loadWhatsAppScript, { once: true });
  window.addEventListener('pointerdown', loadWhatsAppScript, { once: true });
  window.addEventListener('keydown', loadWhatsAppScript, { once: true });

  setTimeout(loadWhatsAppScript, 6000);
})();